<template>
  <!-- Container-fluid starts-->
  <div>
    <!-- can find payment -->
    <div v-if="order.length > 0">
      <Breadcrumbs :title="$t('lbl_EMPBE_PaymentSuccess')" />
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="invoice text-align-last-left">
                  <div>
                    <div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="success-text">
                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                            <h2>{{ $t("lbl_EMPBE_Thankyou") }}</h2>
                            <p>{{ $t("lbl_EMPBE_PaymentSuccessMessage") }}</p>
                            <p>{{ $t("lbl_EMPBE_TransactionId") }}: {{ order[0].eventSid }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <!-- End InvoiceTop-->
                    <div>
                      <div class="order-history success-table table-responsive">
                        <table class="table table-bordernone">
                          <thead>
                            <tr>
                              <th scope="col">{{ $t("lbl_EMPBE_Product") }}</th>
                              <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_Price") }}</th>
                              <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_Quantity") }}</th>
                              <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_ExpiryDate") }}</th>
                              <th class="text-align-last-right" scope="col">{{ $t("lbl_EMPBE_Subtotal") }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in order" :key="index">
                              <td>
                                <div class="product-name">
                                  {{ langid == '1252' ? item.titleEn : langid == '950' ? item.titleTc :
                                    item.titleSc }}
                                </div>
                              </td>
                              <td class="text-align-last-right">{{ item.currency == 840 ? 'USD$' : 'RMB¥' }}{{
                                item.currency == 840 ? item.priceUSD : item.priceRMB }}</td>
                              <td class="text-align-last-right">{{ item.qty }}</td>
                              <td class="text-align-last-right">{{ item.expiryDate }}</td>
                              <td class="text-align-last-right">{{ item.currency == 840 ? 'USD$' : 'RMB¥' }}{{
                                item.currency == 840 ? item.priceUSD * item.qty : item.priceRMB * item.qty }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td class="Rate text-align-last-right">
                                <h6 class="mb-0">{{ $t("lbl_EMPBE_Total") }}</h6>
                              </td>
                              <td class="payment digits text-align-last-right">
                                <h6 class="mb-0">{{ order[0].currency == 840 ? 'USD$' : 'RMB¥' }}{{ order[0].amount }}</h6>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- End Table-->
                      <div><router-link class="btn btn-primary text-light" :to="{ path: '/orderHistory' }">
                          {{ $t("lbl_EMPBE_BackToOrderHistory") }}</router-link></div>

                    </div>
                  </div>
                  <!-- End Invoice-->
                </div>
                <!-- Section ends -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
    <!-- Cant find payment -->
    <div v-if="(order.length == 0 && unsuccesfulCount > 5)">
      <Breadcrumbs :title="$t('lbl_EMPBE_PaymentFailure')" />
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="invoice text-align-last-left">
                  <div>
                    <div>
                      <div class="row">
                        <div class="col-sm-12">
                          <img class="img-100 mb-2" src="../../assets/images/other-images/sad.png" alt="">
                          <div class="success-text">
                            <!-- <i class="fa fa-exclamation-circle" aria-hidden="true"></i> -->
                            <h2>{{ $t("lbl_EMPBE_PaymentFailureMessage") }}</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <!-- End InvoiceTop-->
                    <div>
                      <div><router-link class="btn btn-primary text-light" :to="{ path: '/ecommerce/cart' }">
                          {{ $t("lbl_EMPBE_BackToShoppingCart") }}</router-link></div>

                    </div>
                  </div>
                </div>
                <!-- Section ends -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
    <div v-if="order.length == 0 && unsuccesfulCount <= 5">
      <Breadcrumbs :title="$t('lbl_EMPBE_PaymentProcessing')" />
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="invoice text-align-last-left" v-if="order.length == 0 && unsuccesfulCount <= 5">
                  <div>
                    <div>
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="success-text">
                            <i class="fa fa-refresh"></i>
                            <h2>{{ $t("lbl_EMPBE_PaymentProcessingMessage") }}</h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End InvoiceTop-->
                  </div>
                </div>
                <!-- Section ends -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { PaymentItemService } from '../../_services';

export default {
  components: {
  },
  data() {
    return {
      title: '',
      order: [],
      unsuccesfulCount: 0,
      Refcode: this.$route.query.Refcode
    }
  },
  computed: {

    langid() {
      return localStorage.getItem("currentLangId")
    }
  },
  mounted() {
    this.unsuccesfulCount = 0
    this.GetPaymentByRefCodeOrEventSid();
  },
  methods: {
    GetPaymentByRefCodeOrEventSid() {
      var that = this;
      var eventSid = '';
      PaymentItemService.GetPaymentByRefCodeOrEventSid(this.Refcode, eventSid).then(res => {
        that.order = res;
        if (that.order.length > 0) {
          //success
          that.clearCart();
        } else {
          //failure
          that.unsuccesfulCount += 1;
          if(that.unsuccesfulCount <= 18){
            setTimeout(() => that.GetPaymentByRefCodeOrEventSid(), 10000)
          }
        }
      })
    },
    clearCart() {
      this.$store.dispatch('paymentItem/clearCart');
    },
  }
};
</script>
<style>
.order-history table thead tr th,
.order-history table tbody tr td {
  padding: 0.75rem !important;
}

.text-align-last-right {
  text-align-last: right;
}

.text-align-last-left {
  text-align-last: left;
}</style>